import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import {useTranslation, Trans} from 'react-i18next';


const BrowseCategories = () => {
  const {t} = useTranslation();

  return (
    <div className="backgroundGradient w-100 py-5">
      <Container>
        <h5 className="text-center font-weight-normal ">{t('browseText')} </h5>

        <Row className="justify-content-between mt-5">
          <Col xs={12} sm={true} md={6} lg={true}
               className="d-flex justify-content-center align-items-center pb-4 pb-lg-0">
            <img src={require('../../assets/images/icon-1.png')}/>
            <p style={{fontSize: '14px'}} className="m-0 ml-3 text-white font-weight-bolder">{t('boothsBtn1')}</p>
          </Col>
          <Col xs={12} sm={true} md={6} lg={true}
               className="d-flex justify-content-center align-items-center pb-4 pb-lg-0">
            <img src={require('../../assets/images/icon-3.png')}/>
            <p style={{fontSize: '14px'}} className="m-0 ml-3 text-white font-weight-bolder">{t('boothsBtn3')}</p>
          </Col>
          <Col xs={12} sm={true} md={6} lg={true}
               className="d-flex justify-content-center align-items-center pb-4 pb-lg-0">
            <img src={require('../../assets/images/icon-4.png')}/>
            <p style={{fontSize: '14px'}} className="m-0 ml-3 text-white font-weight-bolder">{t('boothsBtn4')}</p>
          </Col>
          <Col xs={12} sm={true} md={6} lg={true}
               className="d-flex justify-content-center align-items-center pb-4 pb-lg-0">
            <img src={require('../../assets/images/icon-5.png')}/>
            <p style={{fontSize: '14px'}} className="m-0 ml-3 text-white font-weight-bolder">{t('boothsBtn5')}</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default BrowseCategories;